import React, { useContext } from 'react';
//@ts-ignore
import * as styles from './product-specifications.module.css';
import {
    KontentStringValue,
    CTAConfiguration,
    CTALocation,
    KontentProductImage,
} from '../../../types/KontentProps';
import { PageMetadataContext } from '../../templates/PageMetaDataContext';
import { defaultDomainCountryCodes } from '../../global/countries';
import { getMultiChoice } from '../Global/DataUtils';
import CtaLink from '../Global/CtaLink';
import { epigraphCTA } from '.';

export interface ProductSpecificationDocument {
    elements: any;
    cta_label: KontentStringValue;
    cta_location: CTAConfiguration;
    cta_location_anchor_point: KontentStringValue;
    cta_window_action: any;
}

interface Props {
    documents: ProductSpecificationDocument[];
    epigraphCTA?: epigraphCTA;
}

const ProductSpecsLinks: React.FC<Props> = ({ documents, epigraphCTA }) => {
    const ctaAnchorValue =
        documents[0]?.elements?.cta_location_anchor_point?.value;
    const epigraphCtaBoxIcon =
        epigraphCTA?.cta_icons?.value[0]?.elements?.file?.value[0]?.url;
    const epigraphCtaBoxHoverIcon =
        epigraphCTA?.cta_icons?.value[1]?.elements?.file?.value[0]?.url;
    const epigraphCtaSku = epigraphCTA?.sku?.value;
    const epigraphUaCode = epigraphCTA?.ua_code?.value;
    const epigraphCtaTarget =
        getMultiChoice(epigraphCTA?.cta_configuration__cta_window_action) ===
        'new_window'
            ? '_new'
            : 'self';
    const pageMetadata = useContext(PageMetadataContext);

    return (
        <div className={styles.links} id={ctaAnchorValue || undefined}>
            {epigraphCTA && (
                <>
                    <epigraph-ar sku={epigraphCtaSku} ua-code={epigraphUaCode}>
                        <button slot="ar-button" className={styles.epigraphBtn}>
                            <span className={styles.boxIcons}>
                                <img src={epigraphCtaBoxIcon} />
                                <img src={epigraphCtaBoxHoverIcon} />
                            </span>
                            <span>{epigraphCTA?.cta_copy?.value}</span>
                        </button>
                    </epigraph-ar>

                    <div className={styles.helperText}>
                        <CtaLink
                            href={
                                epigraphCTA?.cta_configuration__cta_location
                                    ?.value[0]?.elements?.slug?.url
                            }
                            target={epigraphCtaTarget}
                        >
                            {epigraphCTA?.cta_configuration__cta_label?.value}
                        </CtaLink>
                    </div>
                </>
            )}
            {documents?.map((document) => {
                const isFile = document?.elements?.cta_location?.value[0]
                    ?.elements?.file
                    ? true
                    : false;
                let ctaAnchor = '';
                if (!isFile) {
                    const preferredLanguage =
                        pageMetadata.preferredLanguage || 'default';
                    var slugUrl =
                        defaultDomainCountryCodes.indexOf(
                            preferredLanguage.toLowerCase()
                        ) > -1
                            ? document.elements.cta_location.value[0]?.elements
                                  ?.slug?.url
                            : `/${preferredLanguage.toLowerCase()}${
                                  document.elements.cta_location.value[0]
                                      ?.elements?.slug?.url
                              }`;

                    ctaAnchor = document.elements.cta_location_anchor_point
                        ?.value
                        ? `/#${document.elements.cta_location_anchor_point.value}`
                        : '';
                }

                return (
                    <a
                        key={document.elements.cta_label.value}
                        href={
                            slugUrl
                                ? slugUrl + ctaAnchor
                                : document.elements.cta_location.value[0]
                                      ?.elements?.file?.value[0]?.url || ''
                        }
                        rel={
                            document?.elements?.cta_location?.value[0]?.elements?.file?.value[0]?.url.endsWith(
                                '.pdf'
                            )
                                ? 'nofollow'
                                : ''
                        }
                        target={
                            document.elements.cta_window_action?.value[0]
                                .codename === 'same_window'
                                ? '_self'
                                : '_new'
                        }
                    >
                        {document.elements.cta_label?.value}
                    </a>
                );
            })}
        </div>
    );
};

export default ProductSpecsLinks;
